export const APP_VERSION = '1.0.0';
export const ENABLE_REDUX_LOGGER = false;
export const CLOUD_HOST = 'CLOUDINARY';

export default {};
